/* esm.sh - rxjs@7.8.2/dist/esm/internal/observable/from */
import{scheduled as m}from"rxjs/dist/esm/internal/scheduled/scheduled";import{innerFrom as f}from"rxjs/dist/esm/internal/observable/innerFrom";function e(r,o){return o?m(r,o):f(r)}export{e as from};
//# sourceMappingURL=from.mjs.map